import React, { memo, useState, useCallback } from "react";
import "./MenuToggle.css";

export const Menutoggle = memo((props) => {
  const { setToggleSideDrawer } = props;
  const [toggleChecker, setToggleChecker] = useState(false);

  const handleNav = useCallback(() => {
    let menuTop = document.getElementById("menu_bar_top");
    let menuBottom = document.getElementById("menu_bar_bottom");
    if (toggleChecker) {
      setToggleChecker(false);
      setToggleSideDrawer(false);
      menuTop.classList.remove("openTop");
      menuBottom.classList.remove("openBottom");
    } else {
      setToggleChecker(true);
      setToggleSideDrawer(true);
      menuTop.classList.add("openTop");
      menuBottom.classList.add("openBottom");
    }
    // eslint-disable-next-line
  }, [toggleChecker]);

  return (
    <div id="header_menu" className="header_menu">
      <button onClick={handleNav} aria-label="Right Align">
        <div className="header_menu_toggle">
          <div id="menu_bar_top" className="menu_bar menu_bar_top"></div>
          <div id="menu_bar_bottom" className="menu_bar menu_bar_bottom"></div>
        </div>
      </button>
    </div>
  );
});
